module.exports = __webpack_public_path__ + "a8263fc35bf26d83b5fb2092e1848d6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/story-background.jpg
// module id = 408
// module chunks = 1